import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=f68cb38a&scoped=true&"
import script from "./ChatBody.vue?vue&type=script&lang=js&"
export * from "./ChatBody.vue?vue&type=script&lang=js&"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=f68cb38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68cb38a",
  null
  
)

export default component.exports